import { createValidator, ErrorObject, maxLength, required } from 'util/validation'

import { SolicitacaoRegulacaoModel } from '../model-esusRegulacao'

export const solicitacaoRegulacaoValidator = createValidator<SolicitacaoRegulacaoModel>(
  {
    procedimento: [required],
    centralExecutante: [required],
    cid10: [required],
    classificacaoRisco: [required],
    justificativa: [required, maxLength(2000)],
  },
  (values: SolicitacaoRegulacaoModel, errors: ErrorObject<SolicitacaoRegulacaoModel>) => {
    if (values.possuiAlergia) {
      errors.descricaoAlergia =
        required(values.descricaoAlergia) ?? maxLength(200)(values.descricaoAlergia) ?? undefined
    }

    if (values.possuiDeficiencia) {
      errors.descricaoDeficiencia =
        required(values.descricaoDeficiencia) ?? maxLength(200)(values.descricaoDeficiencia) ?? undefined
    }

    if (values.solicitacaoJudicializada) {
      errors.descricaoSolicitacaoJudicializada =
        required(values.descricaoSolicitacaoJudicializada) ??
        maxLength(200)(values.descricaoSolicitacaoJudicializada) ??
        undefined
    }

    return errors
  }
)
